import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import {
  buildLayoutContentBreakpoint,
  type LayoutContentBreakpoint
} from '~/shared/constants/layoutContentBreakpoint'

export type { LayoutContentBreakpoint }

const useLayoutContentBreakpointStore = defineStore('layout/content-breakpoint', () => {
  const isManaged = ref(false)
  const contentWidth = ref(0)

  const breakpoint = computed(() => buildLayoutContentBreakpoint(contentWidth.value))

  function setContentWidth (width: number): void {
    contentWidth.value = width
    isManaged.value = true
  }

  function reset (): void {
    isManaged.value = false
    contentWidth.value = 0
  }

  return {
    isManaged,
    contentWidth,
    breakpoint,
    isDesktop: computed(() => breakpoint.value.isDesktop),
    isDesktopWithSidebar: computed(() => breakpoint.value.isDesktopWithSidebar),
    isTablet: computed(() => breakpoint.value.isTablet),
    isMobile: computed(() => breakpoint.value.isMobile),
    isCompact: computed(() => breakpoint.value.isCompact),
    setContentWidth,
    reset
  }
})

export default useLayoutContentBreakpointStore
